import { Pipe, PipeTransform } from '@angular/core';

import { StepState } from './../step.state';

@Pipe({
  name: 'sectionProgress',
})
export class SectionProgressPipe implements PipeTransform {

  public transform(value: number, state: StepState): number {
    let from = 0;
    let to = 0;
    let counter = 0;
    state.onboardingSections.forEach((section, index) => {
      if (value === index) {
        from = counter;
        to = counter + section.length;
      } else {
        counter += section.length;
      }
    });
    if (state.step > to) {
      return 100;
    }

    if (state.step <= from) {
      return 0;
    }

    return (state.step - from) / (to - from) * 100;
  }

}
